import { Component, OnInit,OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EchexbaseComponent } from '../echexbase/echexbase.component';
;

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
    selector: 'app-transactions',
    templateUrl: './edittransactions.component.html',
    styleUrls: ['./transactions.component.css'],
    providers: [Modal]
  })
export class EditTransactionsComponent extends EchexbaseComponent implements OnInit, OnDestroy {
    public enterCheque : any={};
    //echexTransactionData; any={};
    busy: Subscription;
    public name :string;
    public amount :string;
    public token :string;
    public id :string;
    public pay_to_the_order_of :string;
    public amountInWords :string;
    public signature_enable_edit : boolean = false;
    public erouting_number :string;
    public eaccount_number :string;
    public econfirm_account_number :string;

    public today_date : Date;
    public bankname  : string;
    public bankaddress : string;
    public bankcity : string;
    public bankzip: string;
    public echeque_signature: string;
	
	public validationName: boolean = false;
	public validationEmail: boolean = false;
	public invalidEmail: boolean = false;

	public validationAddess: boolean = false;
	public validationCity: boolean = false;
	public validationState: boolean = false;
	public validationZip: boolean = false;
  
	public validationCheck_number: boolean = false;
	public validationCheck_amount: boolean = false;
	public validationMemo: boolean = false;
	public validationRouting_number= false;
	public validationAccount_number: boolean = false;
	public validationConfirm_account_number: boolean = false;
	public match: boolean = false;
	public minAccountLength: boolean = false;
	public RecurringEnable : boolean = false;
  public showWarning: boolean = false;
  public characterLimitReached : boolean = false;
  NamecharacterLimitReached: { [key: string]: boolean } = {};

  @ViewChild('submitButton') submitButton: ElementRef;
  @ViewChild('Focus_Selectrecuring') focusSelectRecuring: ElementRef;

	constructor(protected router: Router, private renderer: Renderer2, protected route: ActivatedRoute, private elementRef: ElementRef, protected toastr: ToastrService, protected userService:UserService, protected echexpaymentService :EchexpaymentService, protected localStorageService: LocalstorageService) { 
        super(route, router, toastr, userService, echexpaymentService, localStorageService);
		this.router = router;
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
		
		let userDetails = this.localStorageService.getData("currentUser");
		this.id = userDetails._id;
    this.pay_to_the_order_of = userDetails.business_name ? userDetails.business_name : (userDetails.first_name + ' ' +  userDetails.last_name);
		this.today_date =  new Date();
	}

  ngOnDestroy() {
    this.toastr.clear();
  }

	ngOnInit() {
        this.getEchexTransactionDetail();
	}
	// Get edit Transaction data
	getEchexTransactionDetail() {
		let params: any = this.route.snapshot.params;
		let data = {
		  user_token:this.token,
          token:this.id,
          id:params.id,
          _id:this.id,
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getEchexTransactionDetail(data).subscribe(
		   response => {
			  responseData = response;
              this.enterCheque = responseData.data;
              this.pay_to_the_order_of = responseData.data.to_name;
              this.enterCheque.RecurringEnable = responseData.data.check_recurrent_enable;
              this.RecurringEnable = responseData.data.check_recurrent_enable;
              this.enterCheque.amount = responseData.data.cheque_amount;
              this.amountToWords(responseData.data.cheque_amount.toString());
              this.getRoutingInfo(responseData.data.routing_number);
              if(responseData.data.signature_enable === "1"){
                this.signature_enable_edit = false;
                this.enterCheque.signature_enable = false
              } else {
                this.signature_enable_edit = true;
                this.enterCheque.signature_enable = true
              }
		   },
		   error => {
			 responseData = error;
             this.toastr.error('Get Check details Failed!', responseData.error.message);
		   }
		);
    }
    checkSignature(event: any){
		if(event.target.checked){
            this.signature_enable_edit = true;
        }else{
            this.signature_enable_edit = false;
        }
	}


  checkRecurring(event: any){
    if(event.target.checked){
        this.RecurringEnable = true;
        if (this.focusSelectRecuring) {
          this.moveNext(this.focusSelectRecuring.nativeElement, null);
        }
    }else{
        this.RecurringEnable = false;
        const saveButton = document.getElementById('submitButton') as HTMLElement;
        if (saveButton) {
          saveButton.focus();
          saveButton.click();
        }
    }
  }
  
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  }
  
	// Amount to words
  amountToWords(value) {
    if (value === null || value === undefined) {
      this.amountInWords = '';
    } else {
      const dollars = Math.floor(value);
      const cents = Math.round((value - dollars) * 100);
      let centsText = '';
  
      if (cents !== 0) {
        centsText = `${cents}/100`;
      } else {
        centsText = `00/100`
      }
  
      this.amountInWords = `${this.echexpaymentService.toWords(dollars)}`;
  
      if (centsText) {
        this.amountInWords += ` and ${centsText} Cents`;
      }

    }
  }
  validateInput(event: any) {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
  
    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
      // Allow the default behavior for certain keys
      return;
    }
  
    if (!/^\d+$/.test(event.key)) {
      // Prevent input if it's not a digit
      event.preventDefault();
    }
  }
  
  DisallowZero(event: any) {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
  
    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
      // Allow the default behavior for certain keys
      return;
    }
  
    const inputValue = event.target.value;
    const caretStart = event.target.selectionStart;
    const caretEnd = event.target.selectionEnd;
    const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
    
    if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) {
      this.showWarning = false; // Hide the warning message
      event.preventDefault(); // Prevent invalid input
      return;
    }
    const regex = /^\d{0,9}(\.\d{0,2})?$/;
    const maxValue = 999999999;
    if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
      if (parseFloat(modifiedValue) > maxValue) {
        this.showWarning = true;
        setTimeout(() => {
          this.showWarning = false;
        }, 3000);
        event.preventDefault();
      }
      event.preventDefault();
    } 
  }
  
	//setAmountValue
    setAmountValue(amount){
      this.enterCheque.amount = parseFloat(amount).toFixed(2);
    }


    eventHandler(){
        this.validationName = false;
        this.validationEmail = false;
        this.invalidEmail = false;

        this.validationAddess = false;
        this.validationCity = false;
        this.validationState = false;
        this.validationZip = false;
      
        this.validationCheck_number = false;
        this.validationCheck_amount = false;
        this.validationMemo = false;
        this.validationRouting_number= false;
        this.validationAccount_number = false;
        this.validationConfirm_account_number = false;
        this.match = false;
        this.minAccountLength = false;
    }

    focusFirstInvalidControlPlus(): void {
      const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
      if (firstElementWithErrors) {
          firstElementWithErrors.focus();
      }
    }

    updateCheque(data){
      this.focusFirstInvalidControlPlus();   //focus field
      if(data.valid && this.checkRoutingno === "Success"){ 
        if (data.value.checking_account_number !== data.value.confirm_account_number) {
          return;
        }
        let model: any = data.value;
        if(model.checking_account_number != model.confirm_account_number){
            this.match = true;
            return false;
        }
        let params: any = this.route.snapshot.params;
        
        model.token = this.id,
        model.user_token = this.token,
        model.id = this.id,
        model._id = params.id;
        model.cheque_signature =  model.name;
        model.signature_enable = !this.signature_enable_edit;
        model.to_name =  this.pay_to_the_order_of;
        model.check_recurrent_enable = this.RecurringEnable;
        model.signature_enable = model.signature_enable ? 1 : 0
		let responseData = <any>{};
        this.busy = this.echexpaymentService.updateChequeApi(model).subscribe(
             response => {
				//this.getEchexTransactionDetail();
                this.toastr.success('Success!', 'Check Updated successfully');
             }, 
             error => {
               responseData = error;
               this.toastr.error('Update Failed!', responseData.error.message);
             }
          ); 
    } 
} 
  limitDecimalLength(inputElement: HTMLInputElement) {
    const regex = /^\d{0,9}(\.\d{0,2})?$/;
    const inputValue = inputElement.value;
    
    if (!regex.test(inputValue)) {
      inputElement.value = inputValue.slice(0, -1);
    }
  }

  ngAfterViewInit() {
		this.renderer.selectRootElement('#Focus_name').focus();
	}

  moveNext(nextInput: HTMLInputElement, checkbox: number) {
    if(checkbox === 2){
      const saveButton = document.getElementById('submitButton') as HTMLElement;
      if (saveButton) {
        saveButton.focus();
        saveButton.click();
      }
    } else{
      nextInput && nextInput.focus();
    }
  }

  checkCharacterLimit(event: any) {
		const maxTextLength = 20; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
		const inputValue = event.target.value;
		
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
		  this.characterLimitReached = true; // Set the validation flag to true to show the warning message
		  setTimeout(() => {
			this.characterLimitReached = false; // Hide the warning message after 3 seconds
		  }, 3000);
		  event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	}

  NameCharacterLimit(event: any, fieldName: string, max_length:number) {
		const maxTextLength = max_length; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
			return;
		}
	
		const inputValue = event.target.value;
	
		if (inputValue.length >= maxTextLength) {
			if (allowedKeys.indexOf(inputChar) === -1) {
				this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
				setTimeout(() => {
				this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
				}, 3000);
				event.preventDefault(); // Prevent entering the exceeded character
			}
		}
	}
	isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/transactions/edittransactions.component.ts